import { extendedStaySteps } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ExtendedStayProcess() {
  return (
    <section
      id="extended-stay"
      aria-labelledby="extended-stay-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Planning a Monthly Stay?</Eyebrow>
        </Reveal>
        <h2 id="extended-stay-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>How Extended Stays Work</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
            An extended stay RV park experience in Auburn CA follows a clear process so guests know
            what to expect before a month-to-month reservation is held.
          </p>
        </Reveal>

        <ol className="mt-10 space-y-0 border-t border-border">
          {extendedStaySteps.map((item, i) => (
            <li key={item.step} className="border-b border-border py-10 md:py-8">
              <Reveal delay={i * 0.05}>
                <div className="grid gap-6 lg:grid-cols-12 lg:gap-10">
                  <div className="lg:col-span-3">
                    <h3 className="font-display mt-3 text-2xl tracking-tight md:text-3xl">
                      {item.title}
                    </h3>
                  </div>
                  <div className="lg:col-span-9">
                    <p className="max-w-2xl text-base leading-relaxed text-muted-foreground">
                      {item.copy}
                    </p>
                    {item.note && (
                      <p className="mt-4 max-w-2xl border-l-2 border-accent bg-secondary/40 px-5 py-4 text-sm leading-relaxed text-foreground/85">
                        {item.note}
                      </p>
                    )}
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal delay={0.1}>
          <ResortLink variant="gold" href="/reservations/" className="mt-8 w-full sm:w-auto">
            Ask About Extended Stay
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
